export default __webpack_public_path__ + "static/media/jap-ecommerceImg_4.29040b7f.webp";